import { SupplierAndStockLocationDTO, SupplierTag } from '@luminovo/api-contracts';

export function hasSupplierTag(supplier: Pick<SupplierAndStockLocationDTO, 'tags'>, supplierTag: SupplierTag): boolean {
    return supplier.tags.some(({ tag }) => tag === supplierTag);
}
